var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatColorIconsInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 111.042H21.6666C15.7083 111.042 10.8333 106.167 10.8333 100.208V43.6042C10.8333 40.0833 12.4583 36.8333 15.4374 34.6667L64.9999 0L114.562 34.6667C117.542 36.5625 119.167 40.0833 119.167 43.6042V100.208C119.167 106.167 114.292 111.042 108.333 111.042Z",
    fill: "#67A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 16C21.35 13.4319 23.4319 11.35 26 11.35H104C106.568 11.35 108.65 13.4319 108.65 16V87C108.65 89.5681 106.568 91.65 104 91.65H26C23.4319 91.65 21.35 89.5681 21.35 87V16Z",
    fill: "white",
    stroke: "#C7CBD0",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 111.042H21.6666C15.7083 111.042 10.8333 106.167 10.8333 100.208V46.0417L64.9999 81.25L119.167 46.0417V100.208C119.167 106.167 114.292 111.042 108.333 111.042Z",
    fill: "#0169EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.778 34.2778C51.2771 34.2778 50.7966 34.0788 50.4424 33.7245C50.0882 33.3703 49.8892 32.8898 49.8892 32.3889C49.8892 31.8879 50.0882 31.4075 50.4424 31.0532C50.7966 30.699 51.2771 30.5 51.778 30.5C52.279 30.5 52.7595 30.699 53.1137 31.0532C53.4679 31.4075 53.6669 31.8879 53.6669 32.3889C53.6669 32.8898 53.4679 33.3703 53.1137 33.7245C52.7595 34.0788 52.279 34.2778 51.778 34.2778ZM78.2225 34.2778C77.7215 34.2778 77.2411 34.0788 76.8868 33.7245C76.5326 33.3703 76.3336 32.8898 76.3336 32.3889C76.3336 31.8879 76.5326 31.4075 76.8868 31.0532C77.2411 30.699 77.7215 30.5 78.2225 30.5C78.7235 30.5 79.2039 30.699 79.5581 31.0532C79.9124 31.4075 80.1114 31.8879 80.1114 32.3889C80.1114 32.8898 79.9124 33.3703 79.5581 33.7245C79.2039 34.0788 78.7235 34.2778 78.2225 34.2778Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47C58 47 60.3333 43 65 43C69.6667 43 72 47 72 47",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6706 23.3324C51.6706 23.3324 51.0172 25.3056 48.7937 25.9167C46.5702 26.5279 45.0001 25.1658 45.0001 25.1658",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3294 23.3324C78.3294 23.3324 78.9828 25.3056 81.2063 25.9167C83.4298 26.5278 84.9999 25.1658 84.9999 25.1658",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatColorIconsInvite);
export default __webpack_public_path__ + "static/media/flat-color-icons_invite.d1376723f8c8c46573c6b441b6a7bc63.svg";
export { ForwardRef as ReactComponent };